import { type Environment, getEnvironment } from './getEnvironment';

const isFeatureEnabled = (allowedEnvironments: Environment[]): boolean => {
  const environment = getEnvironment();
  return allowedEnvironments.includes(environment);
};

const isFeatureEnabledBasedOnLanguage = (requiredLanguages: string[]): boolean => {
  const currentLanguage = localStorage.getItem('i18nextLng') ?? 'en-US';
  return requiredLanguages.includes(currentLanguage);
};

export const isLandingPageDetailsEnabled = isFeatureEnabledBasedOnLanguage(['en-US']);
